<template>
  <div>
    <div class="search-form">
      <div class="search-form-left">
        <div class="form">
          <a-form-model
            :model="form"
            layout="inline"
          >
            <a-form-model-item
              label="产品类型："
              prop="productTypeId"
            >
              <a-select
                v-model="form.productTypeId"
                placeholder="请选择产品类型"
                allow-clear
                show-search
                :filter-option="filterOption"
                @inputKeydown="inputKeydown($event, checkResource)"
              >
                <a-select-option
                  v-for="item in productTypetions"
                  :key="item.productTypeId"
                >
                  {{ item.productTypeName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item
              label="补贴方式:"
              prop="time"
            >
              <a-select
                v-model="form.subsidyType"
                placeholder="请选择产品类型"
                allow-clear
                @inputKeydown="inputKeydown($event, checkResource)"
              >
                <a-select-option
                  v-for="item in subsidyTypes"
                  :key="item.subsidyTypeId"
                >
                  {{ item.subsidyTypeName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-form-model>
        </div>

        <div class="ant-btns-mrright">
          <TableActions
            :actions="headerActions"
            @checkResource="checkResource"
            @dragResource="dragResource"
          />
        </div>
      </div>
      <div class="search-form-right">
        <TableActions
          :actions="addActions"
          @add="addProduceType"
          @exportResource="exportProductTypes"
        />
      </div>
    </div>
    <div
      class="table"
    >
      <a-table
        :columns="
          columns"
        :data-source="dataSource"
        :loading="loading"
        :pagination="false"
        style="padding: 16px 0; background-color: #fff;"
        :row-key="(item, index) => index"
        :custom-row="customRow"
      >
        <span
          slot="productTypeName"
          slot-scope="text, record"
        >
          <a-icon
            v-if="isDrag"
            type="drag"
          />
          {{ record.productTypeName }}
        </span>
        <span
          slot="actions"
          slot-scope="text, record"
        >
          <TableActions
            :actions="tableActions"
            :record="record"
            @edit="editProduct(record)"
            @delete="deleteRecord(record)"
          />
        </span>
      </a-table>
    </div>
    <EditProduct
      :init-data="initData"
      :dialog-title="dialogTitle"
      :visible="modalVisible"
      :loading="confirmLoading"
      :subsidy-types="subsidyTypes"
      :product-typetions="productTypetions"
      :action-type="actionType"
      @cancel="handleCancel"
      @ok="handleOk"
    />
  </div>
</template>

<script>
import { queryProductTypes, querySubsidyTypes, deleteProductType, exportProductTypes, changeOrder } from '@/api/productManage.js'
import EditProduct from './EditProductType.vue'
import { excelDown, filterOption, inputKeydown } from '@/utils/utils.js'

import {
  queryAllProductTypes
} from '@/api/common.js'

const columns = [
  {
    title: '产品类型',
    dataIndex: 'productTypeName',
    key: 'productTypeName',
    scopedSlots: { customRender: 'productTypeName' },
    width: '200px'
  },
  {
    title: '补贴方式',
    dataIndex: 'subsidyTypeName',
    key: 'subsidyTypeName',
    width: '200px'
  },
  {
    title: '操作',
    dataIndex: 'actions',
    key: 'actions',
    width: '250px',
    scopedSlots: { customRender: 'actions' }
  }
]
const addActions = [{
  title: '添加产品类型',
  type: 'primary',
  action: 'add',
  apis: ['@baseInfo/Add_Base']
},
{
  title: '导出',
  type: 'primary',
  action: 'exportResource',
  ghost: true,
  apis: ['@baseInfo/Export_Bases']

}]

// const headerActions = [
//   {
//     title: '查询',
//     type: 'primary',
//     action: 'checkResource'
//   },
//   {
//     title: this.isDrag ? '拖拽排序' : '保存',
//     type: 'primary',
//     action: 'dragResource',
//     ghost: true
//   }
// ]

const tableActions = [
  {
    title: '编辑',
    type: 'link',
    action: 'edit',
    apis: ['@baseInfo/Add_Base']
  },
  {
    title: '删除',
    type: 'link',
    action: 'delete',
    apis: ['@baseInfo/Add_Base']
  }
]
export default {
  components: {
    EditProduct
    // CheckChangeRecords
  },
  data () {
    return {
      columns,
      dataSource: [],
      innerDataSource: [],
      loading: false,
      baseId: 0,
      subsidyTypes: [],
      productTypetions: [],
      tableActions,
      addActions,
      headerActions: [{
        title: '查询',
        type: 'primary',
        action: 'checkResource'
      },
      {
        title: '点击进行拖拽排序',
        type: 'primary',
        action: 'dragResource',
        ghost: true
      }],
      modalVisible: false,
      confirmLoading: false,
      initData: null,
      initRecords: null,
      dialogTitle: null,
      form: {
        productTypeId: undefined,
        subsidyType: undefined
      },
      actionType: null,
      sourceObj: undefined,
      isDrag: false,
      serialNoList: [],
      targetIndex: undefined,
      sourceIndex: undefined
    }
  },
  created () {
    this.loading = true
    this.fetchData()
    this.fetchSearchOptions()
  },
  methods: {
    excelDown,
    inputKeydown,
    filterOption,
    async fetchSearchOptions () {
      await querySubsidyTypes().then((data) => {
        this.subsidyTypes = data
      })
      await queryAllProductTypes().then((data) => {
        this.productTypetions = data
      })
    },
    checkResource () {
      this.fetchData()
    },
    dragResource () {
      this.isDrag = !this.isDrag
      this.headerActions[1].title = !this.isDrag ? '点击进行拖拽排序' : '是否保存？'
      if (!this.isDrag) {
        changeOrder({ productTypeOrders: this.serialNoList }).then((data) => {
          if (data) {
            this.$message.success('已保存拖拽后的顺序!')
          }
        })
      }
    },
    // 拖拽
    customRow (record, index) {
      if (this.isDrag) {
        return {
          props: {
            draggable: 'true'
          },
          style: {
            cursor: 'pointer'
          },
          on: {
          // 鼠标移入
            mouseenter: (event) => {
            // 兼容IE
              var ev = event || window.event
              ev.target.draggable = true
            },
            // 开始拖拽
            dragstart: (event) => {
            // 兼容IE
              var ev = event || window.event
              // 阻止冒泡
              ev.stopPropagation()
              // 得到源目标数据
              this.sourceObj = record
              this.sourceIndex = index
              // console.log(record)
              this.serialNoList = []
              document.addEventListener('dragleave', function (ev) {
                ev.target.toggleAttribute('ant-table-row', true)
              })
            },
            // 拖动元素经过的元素
            dragover: (event) => {
            // 兼容 IE
              var ev = event || window.event
              // 阻止默认行为
              ev.preventDefault()
            },
            // 鼠标松开
            // 鼠标松开
            drop: (event) => {
            // 兼容IE
              var ev = event || window.event
              // 阻止冒泡
              ev.stopPropagation()
              // 得到目标数据
              this.targetObj = record
              const tempData = this.dataSource
              tempData[this.targetObj.weight] = this.sourceObj
              tempData[this.sourceObj.weight] = this.targetObj
              // console.log(tempData);
              const weightList = []
              tempData.forEach((item, index) => {
              // debugger
                item.weight = index
                weightList.push({
                  ...item,
                  weight: index
                })

                this.serialNoList.push({
                  productTypeId: String(item.productTypeId),
                  serialNo: String(index)
                })
              })
              // debugger
              // 将值调换就可以实现了
              this.dataSource = weightList
            }
          }
        }
      } else {
        return false
      }
    },
    // 异步获取数据
    async fetchData () {
      this.loading = true
      await queryProductTypes({
        ...this.form
      }).then((data) => {
        this.dataSource = data.result ? data.result : []
      })
      this.loading = false
    },
    editProduct (record) {
      this.initData = record
      this.dialogTitle = '编辑产品类型'
      this.modalVisible = true
      this.actionType = '0'
    },
    addProduceType () {
      this.initData = {
        productTypeId: undefined,
        subsidyTypeId: undefined
      }
      this.modalVisible = true
      this.dialogTitle = '添加产品类型'
      this.actionType = '1'
    },
    deleteRecord (record) {
      this.$confirm({
        title: '确定删除该条记录吗？',
        okText: '确认删除',
        cancelText: '取消',
        onOk: async () => {
          await deleteProductType({
            productTypeId: record.productTypeId
          }).then((data) => {
            if (data) {
              this.$message.success('删除成功!')
              this.fetchData()
              this.fetchSearchOptions()
            } else {
              this.$message.error('存在关联信息，无法删除!')
            }
          })
        }
      })
    },
    handleCancel () {
      this.modalVisible = false
    },
    handleOk () {
      this.handleCancel()
      this.fetchData()
      this.fetchSearchOptions()
    },
    handleChange (value) {
      this.form.time = value
    },
    async exportProductTypes () {
      await exportProductTypes({
        productTypeId: this.form.productTypeId,
        subsidyType: this.form.subsidyType
      }).then((data) => {
        this.excelDown(data, '产品类型')
      })
    }
  }

}
</script>

<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 16px;
}

/deep/.ant-table-body {
  width: 1200px;
  margin: auto;
}

// /deep/ .dragClass {
//   border: 2px solid rgba(0,0,0, 0.5);
// }
</style>
